import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "./primitives";

export const ScriptureMarquee = () => (
  <section data-testid="scripture-marquee" className="py-24 md:py-32 border-y hairline relative z-10 overflow-hidden">
    <Marquee speed={40} gradient={false} className="overflow-hidden">
      {Array.from({ length: 4 }).map((_, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-4xl md:text-6xl font-[200] italic text-white/90 px-8">
            Whatever you do, do it with all your heart, as working for the Lord
          </span>
          <span className="label text-gold px-8">Colossians 3:23</span>
          <Star size={20} className="text-gold mx-8" />
        </span>
      ))}
    </Marquee>
  </section>
);
